import profilePic from "../../images/happy-birthday-background-sign-tropical-beach-hawaii-63372910.jpg.webp";
import "../../styling/InvoiceTab.css";
import "../../styling/ClientPortal.css";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { EventDataContext } from "../EventDataContext";

import businessPhoto from "../../images/BoothBloom_Banner_Business.jpg";
import weddingPhoto from "../../images/BoothBloom_Banner_Wedding.jpg";
import birthdayPhoto from "../../images/BoothBloom_Banner_Birthday.jpg";
import otherPhoto from "../../images/BoothBloom_Banner_Other.jpg";

const PackagesTab = () => {
  const { EventData, setEventData } = useContext(EventDataContext);
  const [chosenPackage, setChosenPackage] = useState({});
  const [addons, setAddons] = useState([]);

  let coverPic = otherPhoto;
  if (EventData.eventType == "corporate") {
    coverPic = businessPhoto;
  } else if (EventData.eventType == "birthday") {
    coverPic = birthdayPhoto;
  } else if (EventData.eventType == "wedding") coverPic = weddingPhoto;

  const fetchPackage = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/business/getPackageDetail/${EventData.packageId}`,
        { withCredentials: true }
      );
      setChosenPackage(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAddons = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/business/getAddonDetail/${EventData._id}`,
        { withCredentials: true }
      );
      setAddons(response.data.addons);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchPackage();
    fetchAddons();
  }, [EventData]);

  return (
    <div style={{ width: "100%" }} className="packages-client-tab">
      <div style={{ position: 'relative', width: '100%', height: '224px', overflow: 'hidden', backgroundColor: '#000' }}>
        {/* 1. The Base Image */}
        <img
          src={coverPic}
          alt="cover"
          style={{ 
            width: "100%", 
            height: "100%", 
            objectFit: "cover",
            objectPosition: "top" 
          }}
        />

        {/* 2. The Blur Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backdropFilter: 'blur(8px)', 
          WebkitBackdropFilter: 'blur(8px)',
          maskImage: 'radial-gradient(circle, transparent 30%, black 80%)',
          WebkitMaskImage: 'radial-gradient(circle, transparent 30%, black 80%)',
        }} />
        
        {/* 3. The Bottom Gradient & Text Overlay */}
        <div style={{
          position: 'absolute',
          bottom: '0',
          left: '0',
          width: '100%',
          background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
          color: 'white',
          padding: '20px',
          boxSizing: 'border-box'
        }}>
          <h1 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold' }}>
            Your Package
          </h1>
          <p style={{ margin: '5px 0 0 0', fontSize: '14px', opacity: 0.9 }}>
            Date Booked: {new Date(EventData.eventDate).toLocaleDateString("en-US")}
          </p>
        </div>
      </div>

      <div>
      <div className="invoiceContent">
          {/* 1. PACKAGE SECTION FIX: Changed padding from "0px" to "20px" */}
          <div
            className="right-panel-content"
            style={{ marginTop: "0px", padding: "20px" }} 
          >
            {/* Added Flexbox to ensure the price stays on the right */}
            <div className="right-panel-arrow-container" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <h2
                style={{
                  marginTop: "0px",
                  marginBottom: "5px",
                  fontWeight: "bold",
                  color: "black",
                }}
              >
                {chosenPackage?.name || "Package Name"}
              </h2>
              <h4
                style={{
                  margin: "0",
                  color: "#000000",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center"
                }}
              >
                ${chosenPackage?.cost || "0.00"}
              </h4>
            </div>

            {/* DESCRIPTION FIX: Copied the exact clean mapping from BusinessPackagesTab */}
            <div style={{ color: "#4D4D4D", fontSize: "0.95em", marginTop: "10px" }}>
              {(chosenPackage?.description || "").split("\n").map((feature, i) => (
                <p key={i} style={{ margin: "3px 0" }}>{feature}</p>
              ))}
            </div>
          </div>
          
          <h2 style={{ marginTop: "30px", color: "#000000" }}>Add Ons</h2>

          {addons?.map((addon, index) => (
            <div
              className="bordered-box"
              key={index}
              style={{ 
                display: "flex",                  // <-- FIX: Added Flexbox to prevent stacking
                justifyContent: "space-between",  // <-- FIX: Pushes price to the right
                marginBottom: "20px",
                padding: "20px"                   // <-- FIX: Added padding inside the addon box
              }}
            >
              <div className="content" style={{ flex: 1 }}>
                <div style={{ color: "#000000", fontWeight: "bold" }}>
                  {addon.name}
                </div>
                
                {/* DESCRIPTION FIX: Copied from BusinessPackagesTab */}
                <div style={{ color: "#555", marginTop: "7px", fontSize: "0.9em" }}>
                  {(addon?.description || "").split("\n").map((feature, i) => (
                    <p key={i} style={{ margin: "3px 0" }}>{feature}</p>
                  ))}
                </div>
              </div>

              <div>
                <p
                  className="rightmost-content"
                  style={{
                    margin: "0",
                    color: "#000000",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center"
                  }}
                >
                  ${addon.cost}
                  
                </p>
              </div>
            </div>
          ))}

          {/* TOTALS SECTION */}
          <div
            style={{
              borderTop: "1px solid #D9D9D9",
              color: "#625C73",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              paddingTop: "20px",
              marginTop: "30px",
            }}
          >
            <div>Subtotal</div>
            <div style={{ width: "20%" }}></div>
            <div>${EventData?.expPaymentAmount}</div>
          </div>
          <div
            style={{
              borderBottom: "1px solid #D9D9D9",
              color: "#625C73",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              paddingBottom: "20px",
              paddingTop: "10px",
            }}
          >
            <div>Total</div>
            <div style={{ width: "20%" }}></div>
            <div>${EventData?.expPaymentAmount}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackagesTab;